/**
 * i18n Basic translation
 * All kind of strings that are very used and shown in multiple apps
 */

// @todo reserved key 'translations' from books summary

const common = {
  en: {
    Ok: 'Ok',
    Remove: 'Remove',
    Unfiltered: 'Unfiltered',
    'Lines filter': 'Lines filter',
    Oracle: 'Oracle',
    Explorer: 'Explorer',
    Settings: 'Settings',
    'Sorting options': 'Sorting options',
    'Earlier heaven': 'Earlier heaven',
    'Later heaven': 'Later heaven',
    'Binary ascending': 'Binary ascending',
    'Binary descending': 'Binary descending',
    Judgment: 'Judgment',
    Image: 'Image',
    Lines: 'Lines',
    lines: 'lines',
    Mutation: 'Mutation',
    'Constituent line': 'Constituent line',
    'Leading line': 'Leading line',
    OnlyAvailableTranslation:
      '“%{translation}” is the only available translation'
  },
  es: {
    Ok: 'De acuerdo',
    Remove: 'Eliminar',
    Unfiltered: 'No filtrado',
    'Lines filter': 'Filtro de líneas',
    Oracle: 'Oráculo',
    Explorer: 'Explorador',
    Settings: 'Ajustes',
    'Sorting options': 'Opciones de ordenación',
    'Earlier heaven': 'El cielo temprano',
    'Later heaven': 'El cielo tardío',
    'Binary ascending': 'Binaria ascendente',
    'Binary descending': 'Binaria descendente',
    Judgment: 'Juicio',
    Image: 'Imagen',
    Lines: 'Líneas',
    lines: 'líneas',
    Mutation: 'Mutación',
    'Constituent line': 'Línea constituyente',
    'Leading line': 'Línea gobernante',
    OnlyAvailableTranslation:
      '“%{translation}” es la única traducción disponible'
  }
};

export default common;
